import { render, staticRenderFns } from "./destinasiLainnya.vue?vue&type=template&id=195c9112&"
import script from "./destinasiLainnya.vue?vue&type=script&lang=js&"
export * from "./destinasiLainnya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports